<template>
  <v-layout row wrap>
    <v-flex xs6>
      <v-form class="px-2">
        <!-- Rule Set Type -->
        <v-flex xs4>
          <v-select v-model="ruleSetInfo.type" item-text="title" item-value="value" :disabled="isEditMode"
            @change="updateAddRulesFilters(); handleRuleSetTypeChange()" :label="messages.label.RULE_SET_TYPE"
            :items="ruleSetTypeList"></v-select>
        </v-flex>
        <!-- Rule Title -->
        <v-flex xs10>
          <v-text-field v-model="ruleSetInfo.title" clearable v-validate="{ required: true, max:100, regex: /^[0-9a-zA-Z\s\/_-]*$/i }"
            :error-messages="errors.collect('title')" data-vv-name="title" :counter="100"
            :label="messages.label.RULE_TITLE" required>
          </v-text-field>
        </v-flex>
        <!-- Rule Description -->
        <v-flex xs10>
          <v-textarea v-model="ruleSetInfo.description" clearable v-validate="{max:500}"
            :error-messages="errors.collect('description')" data-vv-name="description" :counter="500"
            :label="messages.label.RULE_DESCRIPTION" required>
          </v-textarea>
        </v-flex>
        <!-- Rule Enabled -->
        <v-flex xs4>
          <span class="subheading">{{ messages.label.ENABLED }}</span>
          <v-switch v-model="ruleSetEnabled" color="primary" class="mt-0" :label="`${ruleSetEnabled.toString()}`">
          </v-switch>
        </v-flex>
      </v-form>
    </v-flex>
  </v-layout>

</template>
<script>
import { mapMutations } from "vuex"
import messages from "@/XVAT/messages.json"
import XVATRulesService from "@/XVAT/XVATRulesService"
import { SET_ADD_RULES_FILTERS, SET_RULESET_RULES } from "@/store/constants/mutation-types"
import {
  RULE_TYPE_VALIDATION
} from "../constants"

export default {
  name: "RuleSetInfo",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      ruleSetTypeList: XVATRulesService.getRuleTypeList(),
      isEditMode: false,
      ruleSetInfo: {
        type: RULE_TYPE_VALIDATION,
        title: "",
        description: "",
        enabled: true
      },
      ruleSetEnabled: true, // NOTE: Using this outside of 'ruleSetInfo' as binding is not working
      dictionary: this.getValidationDictionary()
    }
  },
  methods: {
    ...mapMutations("xvat", [
      SET_ADD_RULES_FILTERS,
      SET_RULESET_RULES
    ]),

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters",
            regex: "Valid characters are : A-Z a-z 0-9 / _ -"
          },
          description: {
            max: "Description may not be greater than 500 characters"
          }
        }
      }
    },

    /**
     * resetData - Reset rule info data
     */
    resetData() {
      this.ruleSetInfo = {
        type: RULE_TYPE_VALIDATION,
        title: "",
        description: "",
        enabled: true
      }
      this.ruleSetEnabled = true
      this.isEditMode = false
    },

    /**
     * resetRuleSetInfo - Reset rule data and form
     */
    resetRuleSetInfo() {
      this.resetData()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },

    /**
     * loadRuleSetInfo - update view with ruleset data
     * @param {object} ruleSetData
     */
    loadRuleSetInfo(ruleSetData) {
      this.resetRuleSetInfo()
      if (!this.$lodash.isUndefined(ruleSetData)) {
        this.isEditMode = true
        this.ruleSetInfo.type = ruleSetData.type
        this.ruleSetInfo.title = ruleSetData.title
        this.ruleSetInfo.description = decodeURI(ruleSetData.description)
        this.ruleSetInfo.enabled = !ruleSetData.disabled
        this.ruleSetEnabled = this.ruleSetInfo.enabled // UI Specific
        this.updateAddRulesFilters()
      } else {
        this.isEditMode = false
      }
    },

    /**
     * validate - Validate
     */
    validate() {
      this.$validator.validateAll()
        .then((result) => {
          this.ruleSetInfo.enabled = this.ruleSetEnabled // Please see note at the definition of this property in 'data'
          if (this.$lodash.isNull(this.ruleSetInfo.description)) {
            this.ruleSetInfo.description = ""
          }
          XVATRulesService.$emit("event:ruleSetInfoValidation", result, this.ruleSetInfo)
        })
    },

    /**
     * updateAddRulesFilters - Update to ensure that 'Add Rules' fetches correct data
     */
    updateAddRulesFilters() {
      let addRulesFilters = {
        ruleSetType: this.ruleSetInfo.type
      }
      this.SET_ADD_RULES_FILTERS(addRulesFilters)
      XVATRulesService.$emit("event:addRulesFilterUpdated")
    },
    /**
     * handleRuleSetTypeChange - Update the RulesSetRulesList when user change the ruleType
     */
    handleRuleSetTypeChange() {
      let ruleSetRulesList = []
      this.SET_RULESET_RULES(ruleSetRulesList)
      XVATRulesService.$emit("event:ruleSetTypeChanged", this.ruleSetInfo.type)
    }
  },
  mounted() {
    // Validator initialization
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    this.updateAddRulesFilters()

    /**
     * Events
     */
    XVATRulesService.$on("event:ruleSetDataRetrieved", this.loadRuleSetInfo)
    XVATRulesService.$on("event:validateRuleSetInfo", this.validate)
  },
  beforeDestroy() {
    XVATRulesService.$off("event:validateRuleSetInfo", this.validate)
    XVATRulesService.$off("event:ruleSetDataRetrieved", this.loadRuleSetInfo)
  }
}
</script>
<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/XVAT/RuleSet/RuleSetInfo.vue